<template>
    <div id="portfolio" class="SkillsView ssection">
        <div>
            <h2>Languages</h2>
            <div class="center-box">
                <div class="progress-row">
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_c.svg" alt class="icon-fluid" />
                            <p>C</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_cpp.svg" alt class="icon-fluid" />
                            <p>C++</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_java.svg" alt class="icon-fluid" />
                            <p>Java</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_html5.svg" alt class="icon-fluid" />
                            <p>HTML5</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_css3.svg" alt class="icon-fluid" />
                            <p>CSS3</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_angular.svg" alt class="icon-fluid" />
                            <p>AngularJS</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_react.svg" alt class="icon-fluid" />
                            <p>ReactJS</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_vue.svg" alt class="icon-fluid" />
                            <p>VueJS</p>
                        </div>
                    </div>
                    <div class="portfolio-box-6">
                        <div class="icon">
                            <img src="../assets/about/icon_flutter.svg" alt class="icon-fluid" />
                            <p>FLUTTER</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'SkillsView',
}
</script>
  
<style>
.SkillsView {
    background-size: cover;
    display: block;
    width: 100%;
    height: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #FFFCF4;
}

.progress-row {
    display: block;
    margin-top: 5%;
    margin-bottom: 5%;
    padding: 0% 30%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: 100%;
    height: auto;
}

.icon p {
    margin-top: 0%;
    text-align: center;
    color: #c17a00;
    font-size: medium;
}

.icon-fluid {
    max-width: 100%;
    max-height: 100%;
}

.icon {
    position: relative;
    vertical-align: middle;
    border-style: none;
    margin: 0px 10px 0px 10px;
}

.portfolio-box-6 {
    box-sizing: border-box;
    display: block;
    max-width: 20%;
    flex-basis: 20%;
    /*border: yellow solid; 
    max-width: 14.2857143%;
    flex-basis: 14.2857143%;*/
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 16px;
    line-height: 24px;
    width: 240px;
}

@media screen and (max-width: 1024px) {
    .portfolio-box-6 {
        max-width: 25%;
        flex-basis: 25%;
    }

    .progress-row {
        padding: 0% 25%;
    }
}

@media screen and (max-width: 768px) {
    .portfolio-box-6 {
        max-width: 33%;
        flex-basis: 33%;
    }

    .progress-row {
        padding: 0% 20%;
    }
} 

@media screen and (max-width: 650px) {
    .portfolio-box-6 {
        max-width: 33%;
        flex-basis: 33%;
    }

    .progress-row {
        padding: 0% 15%;
    }
}

@media screen and (max-width: 400px) {
    .portfolio-box-6 {
        max-width: 50%;
        flex-basis: 50%;
    }

    .progress-row {
        padding: 0% 15%;
    }
} 
</style>
  